import { USER_ID_KEY } from '../config/constants';

// In-memory fallback when localStorage is unavailable (e.g. private mode).
let _memoryUserID = null;

function generateUUID() {
    if (typeof crypto !== 'undefined' && crypto.randomUUID) {
        return crypto.randomUUID();
    }
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = Math.random() * 16 | 0;
        const v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}

export function getUserID() {
    try {
        let userID = localStorage.getItem(USER_ID_KEY);
        if (!userID) {
            userID = generateUUID();
            localStorage.setItem(USER_ID_KEY, userID);
        }
        return userID;
    } catch (e) {
        if (!_memoryUserID) {
            _memoryUserID = generateUUID();
        }
        return _memoryUserID;
    }
}

export function regenerateUserID() {
    const userID = generateUUID();
    try {
        localStorage.setItem(USER_ID_KEY, userID);
    } catch (e) {
        // ignore, fall back to memory
    }
    _memoryUserID = userID;
    return userID;
}
